<template>
  <v-card class="mx-auto mt-10" max-width="600">
    <v-card-title>Register</v-card-title>
    <v-card-subtitle class="red--text" v-if="registerError">{{
      registerError
    }}</v-card-subtitle>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          v-model="firstName"
          label="First name"
          :error-messages="firstNameErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
        <v-text-field
          v-model="lastName"
          label="Last name"
          :error-messages="lastNameErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
        <v-text-field
          v-model="email"
          label="Email"
          :error-messages="emailErrors"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          :error-messages="passwordErrors"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
          error-count="5"
          type="password"
          required
        ></v-text-field>
        <v-text-field
          v-model="gluidId"
          label="Give your Gluid area a name"
          required
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="submit" :disabled="loading">
        Register
        <v-progress-circular indeterminate v-if="loading"></v-progress-circular
      ></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, minLength, email, alpha } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import store from "@/store";
import _ from "lodash";

export default {
  watch: {
    firstNameAndLastname(e) {
      this.gluidId = e;
    }
  },
  name: "VuelidateRegister",
  validations: {
    firstName: {
      required,
      minLength: minLength(2),
      alpha
    },
    lastName: {
      required,
      minLength: minLength(2),
      alpha
    },
    email: { required, email },
    password: {
      required,
      minLength: minLength(8)
    }
  },
  computed: {
    firstNameAndLastname() {
      return `${_.toLower(this.firstName.replace(/\s+/g, ""))}${_.toLower(
        this.lastName.replace(/\s+/g, "")
      )}`;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.required && errors.push("First name is required");
      !this.$v.firstName.alpha &&
        errors.push("Only alphabet characters are allowed");
      !this.$v.firstName.minLength &&
        errors.push("First name must have minimum 2 characters");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.required && errors.push("Last name is required");
      !this.$v.lastName.alpha &&
        errors.push("Only alphabet characters are allowed");
      !this.$v.lastName.minLength &&
        errors.push("Last name must have minimum 2 characters");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required");
      !this.$v.password.minLength &&
        errors.push("Password must have minimum 8 characters");
      return errors;
    }
  },
  methods: {
    ...mapActions("cognito", ["registerUser"]),
    async submit() {
      this.registerError = null;

      if (!this.$refs.form.validate()) return;
      if (
        !this.email ||
        !this.password ||
        !this.firstName ||
        !this.lastName ||
        !this.gluidId
      ) {
        this.registerError = "Please fill in the fields";
        return;
      }
      try {
        this.loading = true;
        await store.dispatch("auth/register", {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          gluidId: this.gluidId
        });
        this.loading = false;
        this.$router.replace("/login");
      } catch (err) {
        this.loading = false;
        if (err.code === "UsernameExistsException") {
          this.registerError = "Please provide a different Gluid area name";
        } else {
          this.registerError = err.message;
        }
      }
    }
  },
  data: () => ({
    email: "",
    password: null,
    firstName: "",
    lastName: "",
    registerError: "",
    loading: false,
    gluidId: ""
  })
};
</script>

<style scoped></style>
